export enum ProductTypeId {
    Base = 1,
    Discount = 2,
    New = 3
}

export interface ApiRequestInterface {
    catalogCode?: string
    id?: string[]
    typeId?: ProductTypeId
}